import React from "react";

const rows = Array.from({ length: 6 });

const BalanceTableShimmer = () => {
  return (
    <div className="border rounded-lg overflow-x-auto">
      <div className="min-w-[640px]">
        {/* Header */}
        <div className="grid grid-cols-7 text-xs font-medium bg-gray-50 px-3 py-2">
          <span></span>
          <span>Date</span>
          <span className="col-span-2">Transaction</span>
          <span className="col-span-2">Ref ID</span>
          <span>Balance</span>
        </div>

        {/* Body */}
        <div className="max-h-64 overflow-y-auto">
          {rows.map((_, i) => (
            <div
              key={i}
              className="grid grid-cols-7 items-center px-3 py-3 border-t"
            >
              {/* icon */}
              <div className="h-6 w-6 rounded-full shimmer"></div>

              {/* date */}
              <div className="h-3 w-16 rounded shimmer"></div>

              {/* transaction */}
              <div className="col-span-2 h-3 w-28 rounded shimmer"></div>

              {/* ref id */}
              <div className="col-span-2 h-3 w-32 rounded shimmer"></div>

              {/* balance */}
              <div className="h-3 w-14 rounded shimmer ml-auto"></div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default BalanceTableShimmer;
